import { render, staticRenderFns } from "./header-accounts-menu.vue?vue&type=template&id=60cff48a&"
import script from "./header-accounts-menu.vue?vue&type=script&lang=js&"
export * from "./header-accounts-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports